import React, { useState } from "react";
import { Swords, ShieldAlert, Skull } from "lucide-react";
import FightLogs from "./FightLogs";
import RaidLogs from "./RaidLogs";
import CrimeLogs from "./CrimeLogs";

export default function History() {
  const [activeSubTab, setActiveSubTab] = useState("COMBAT");

  const subTabs = [
    { id: "COMBAT", icon: <Swords size={16} />, label: "Street Beefs" },
    { id: "RAIDS", icon: <ShieldAlert size={16} />, label: "Fed Activity" },
    { id: "CRIMES", icon: <Skull size={16} />, label: "The Scores" },
  ];

  return (
    <div className="space-y-6 animate-in fade-in zoom-in duration-500">
      <div className="border-b border-zinc-800 pb-4 flex justify-between items-end">
        <div>
          <h2 className="text-4xl font-black italic uppercase text-white tracking-tighter">
            Operational <span className="text-green-500">History</span>
          </h2>
          <p className="text-zinc-500 text-[10px] uppercase tracking-[0.3em]">
            Archives & Intelligence
          </p>
        </div>
      </div>

      {/* Sub-Tab Navigation */}
      <div className="flex gap-1 bg-zinc-900/50 p-1 border border-zinc-800">
        {subTabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveSubTab(tab.id)}
            className={`flex-1 flex items-center justify-center gap-2 py-3 text-[10px] font-black uppercase italic transition-all ${
              activeSubTab === tab.id
                ? "bg-green-600 text-black translate-y-[-2px] shadow-[0_4px_0_0_#166534]"
                : "text-zinc-500 hover:text-white"
            }`}
          >
            {tab.icon} {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div
        key={activeSubTab}
        className="animate-in slide-in-from-bottom-4 duration-300"
      >
        {activeSubTab === "COMBAT" && <FightLogs />}
        {activeSubTab === "RAIDS" && <RaidLogs />}
        {activeSubTab === "CRIMES" && <CrimeLogs />}
      </div>
    </div>
  );
}
